<template>
    <b-table-simple borderless v-if="reminders.length > 0">
        <b-tbody>
            <b-tr>
                <b-th></b-th>
                <b-th class="text-center">Given</b-th>
                <b-th class="text-center">Due</b-th>
            </b-tr>
            <b-tr v-for="reminder in reminders" :key="reminder.id">
                <b-th
                    ><i :class="getIcon(reminder)"></i>
                    {{ reminder.name }}</b-th
                >
                <b-td class="text-center pr-3">
                    <span
                        v-if="
                            reminder.start == null && reminder.record_date > 0
                        "
                        class="record-field text-nowrap"
                        :title="
                            reminder.record_item_name +
                            ' given on ' +
                            _setDateDisplay(reminder.record_date)
                        "
                    >
                        {{ _setDateDisplay(reminder.record_date) }}
                    </span>
                    <span v-else class="text-nowrap">{{
                        _setDateDisplay(reminder.start)
                    }}</span>
                </b-td>
                <b-td class="text-center text-nowrap">{{
                    _setDateDisplay(reminder.due)
                }}</b-td>
            </b-tr>
        </b-tbody>
    </b-table-simple>
</template>
<script>
export default {
    props: {
        reminders: {
            type: [Object, Array]
        }
    },
    methods: {
        getIcon(reminder) {
            let icon = "cus-accept";

            let start = this._now().startOf("day");
            let due = this._toDateTime(reminder.due).endOf("day");
            let nextDue = this._now().endOf("day").plus({ months: 1 });

            if (start > due) {
                icon = "cus-stop";
            } else if (due <= nextDue) {
                icon = "cus-error";
            }

            return icon;
        }
    }
};
</script>
<style type="text/css" lang="scss" scoped>
table tbody tr td:first-child {
    font-weight: bold;
}

.table th,
.table td {
    padding: 0px;
    line-height: 30px;
}
</style>
